import CryptoJS from 'crypto-js';

const key = 'hj7x89H$yuBI0456';
// 偏移量 16位（不可随意修改，否则前后端加密解密可能失败）
const iv = 'NIfb&95GUY86Gfgh';

// 加密
export const encrypt = (data: any) => {
  return CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(data), CryptoJS.enc.Utf8.parse(key), {
    iv: CryptoJS.enc.Utf8.parse(iv),
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  })
    .toString();
};

// 解密
export const decrypt = (data: any) => {
  const decrypted = CryptoJS.AES.decrypt(data, CryptoJS.enc.Utf8.parse(key), {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  return decrypted.toString(CryptoJS.enc.Utf8).toString();
};